import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@clara/server/src/routers/_app";

export const trpc = createTRPCReact<AppRouter>();
